import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, map, Observable, ReplaySubject, shareReplay } from 'rxjs';
import { GraphQLComparision } from '../../../../../enums/GraphQLComparision.enum';
import { ControlWidgetService } from '../../../../../services/ControlWidgetService.service';
import { IGraphQlService } from '../../../../../services/GraphQl/IGraphQL.service';
import { EveReportingWidgetDataSource } from '../widget-datasource.component';




@Component({
  selector: 'widget-multi-datasource',
  templateUrl: 'widget-multi-datasource.component.html',
  styleUrls: ['./widget-multi-datasource.component.css']
})
export class WidgetMultiDataSourceComponent implements OnInit, DoCheck {

  @Input()
  dataSource?: EveReportingWidgetMultiDataSource = null;


  schema: Observable<any>;
  schemaTest: Observable<any>;
  queryFields: Observable<any[]>;
  queryField: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  returnType: Observable<any>;
  returnTypeFeilds: Observable<any[]>;

  GraphQLComparision = GraphQLComparision;

  controlWidgetValueRequired: boolean = false;


  constructor(
    public graphQlService: IGraphQlService,
    public controlWidgetService: ControlWidgetService
  ) {
    this.schema = this.graphQlService.getSchema().pipe(
      map(reponse => reponse.data.__schema),
      shareReplay()
    );

   

    this.schemaTest = this.graphQlService.getSchema();
   

    this.schemaTest.pipe(
      map(st => {
        const test = st.types
      })
    )



    this.queryFields = this.schema.pipe(
      map(schema => {
        const query = schema.types.find(s => s.name == schema.queryType.name);
        return query.fields;
        // return query.fields.filter(a => a.description.indexOf('Supports: Aggeration') > -1 );
      })
    );

    this.returnType = combineLatest(this.schema, this.queryField).pipe(
      map(([schema, queryField]) => {
        const returnType = schema.types.find(t => t.name == queryField?.type.name);
        const itemsField = returnType?.fields.find(f => f.name == "items");
        const itemType = schema.types.find(t => t.name == itemsField?.type.ofType.ofType.name);


  
        return itemType;
      })
    )

    this.returnTypeFeilds = this.returnType.pipe(
      map(returnType => {
        return returnType.fields.filter(a => a.description?.indexOf('Supports: Aggeration') > -1);
      })
    )

  }
    

  ngOnInit(): void {
   
  }

  ngDoCheck(): void {

    if (this.queryField.value?.name != this.dataSource?.queryField) {
      this.queryFields.toPromise().then(queryFields => {
        const queryField = queryFields.find(f => f.name == this.dataSource.queryField)
        this.queryField.next(queryField);
      })
    }
  }


  


  onAddWhereClick() {
    if (this.dataSource.wheres == null) this.dataSource.wheres = [];

    this.dataSource.wheres.push({} as EveReportingWidgetDataSourceFilter)
  }

  getReturnFields(schema: any): any[] {
    const queryType = schema.types.find(t => t.name == "Query");
    const queryField = queryType.fields.find(t => t.name == this.dataSource.queryField);
    const returnType = schema.types.find(t => t.name == queryField.type.name);
    const itemsField = returnType?.fields.find(f => f.name == "items");
    const itemType = schema.types.find(t => t.name == itemsField?.type.ofType.ofType.name);
    
    return itemType.fields.filter(a => ['HierarchyId'].indexOf(a.type?.name) == -1);
  }


  getSelectFields(schema: any): any[] {
    const fields = this.getReturnFields(schema);
    return fields;
  }


  getFieldType(_schema: any, fieldName: any) {

    const fieldType = this.getReturnFields(_schema).find(f => f.name == fieldName);
    if (fieldType == null) return null;
    return fieldType;
  }

  getComparisons(fieldType: any) {

    return comparisonMapping[fieldType.type.name ?? fieldType.type.ofType?.name ];
  }

 
}

const numberComparisons = [GraphQLComparision.EQUAL,
  GraphQLComparision.NOT_EQUAL,
  GraphQLComparision.GREATER_THAN,
  GraphQLComparision.GREATER_THAN_OR_EQUAL,
  GraphQLComparision.LESS_THAN,
  GraphQLComparision.LESS_THAN_OR_EQUAL,
  //"CONTAINS",
  //"DOES_NOT_CONTAIN",
  //"STARTS_WITH",
  //"ENDS_WITH",
  GraphQLComparision.IN,
    //"LIKE",
    //"NOT_IN",
    //"LAST",
  //"IS_DESCENDANT_OF"
];

const comparisonMapping = {
  "Int": numberComparisons,
  "Long": numberComparisons,
  "String": [
    GraphQLComparision.EQUAL,
    GraphQLComparision.NOT_EQUAL,
    //"GREATER_THAN",
    //"GREATER_THAN_OR_EQUAL",
    //"LESS_THAN",
    //"LESS_THAN_OR_EQUAL",
    GraphQLComparision.CONTAINS,
    GraphQLComparision.DOES_NOT_CONTAIN,
    GraphQLComparision.STARTS_WITH,
    GraphQLComparision.ENDS_WITH,
    GraphQLComparision.IN,
    GraphQLComparision.LIKE,
    GraphQLComparision.NOT_IN,
    //"LAST",
    //"IS_DESCENDANT_OF"
  ],
  "DateTimeOffset": [
    GraphQLComparision.EQUAL,
    GraphQLComparision.NOT_EQUAL,
    GraphQLComparision.GREATER_THAN,
    GraphQLComparision.GREATER_THAN_OR_EQUAL,
    GraphQLComparision.LESS_THAN,
    GraphQLComparision.LESS_THAN_OR_EQUAL,
    //"CONTAINS",
    //"DOES_NOT_CONTAIN",
    //"STARTS_WITH",
    //"ENDS_WITH",
    //"IN",
    //"LIKE",
    //"NOT_IN",
    //"LAST",
    //"IS_DESCENDANT_OF"
  ],
  "Boolean": [
    "EQUAL",
    "NOT_EQUAL"
  ]
}



export interface EveReportingWidgetMultiDataSource extends EveReportingWidgetDataSource {
  url?: string,
  queryField?: string,

  xAxis?: string,
  yAxis?: string,
  legend?: string,
  wheres?: EveReportingWidgetDataSourceFilter[]
}


export interface EveReportingWidgetDataSourceFilter {
  path: string,
  comparison: GraphQLComparision,
  isControlWidget: boolean,
  value: any
}

